<template>
    <div :class="[
        'radio-group',
        themeClass
    ]">
        <Radio 
            v-for="option in options" 
            :key="option.value"
            :name="name"
            :label="option.label"
            :value="option.value"
            :is-checked="option.value === selected"
            @click="onClickRadio"
        />
    </div>
</template>

<script>
import Radio from '@/components/form/Radio'
import ThemeClassMixin from '@/mixins/ThemeClassMixin'

export default {
    mixins: [
        ThemeClassMixin
    ],

    components: {
        Radio
    },

    props: {
        name: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        selected: {
            required: false,
            default: null
        }
    },

    data () {
        return {
            themeClassPrefix: 'radio-group--'
        }
    },
    
    methods: {
        onClickRadio(value) {
            this.$emit('change', value)
        }
    }
}
</script>

<style lang="scss">
.radio-group {
    &--compact {
        text-align: left;
        max-width: 195px;

        .radio {
            margin-left: 0;
            margin-top: 10px;
            padding-left: 10px;

            > label {
                &.text-upper {
                    text-transform: none;
                }

                &.fs-18 {
                    font-size: 1.6rem;
                }
            }
        }
    }
}
</style>
